import { useEffect } from "react";
import { SendBirdProvider } from "@sendbird/uikit-react";
import GroupChannelUI from "@sendbird/uikit-react/GroupChannel/components/GroupChannelUI";
import { GroupChannelProvider } from "@sendbird/uikit-react/GroupChannel/context";
import CustomMessage from "./CustomMessage";
import CustomInput from "./CustomInput";
import useChatInit from "../../hooks/agent/useChatInit";
import ActionButton from "../Buttons/ActionButton";
import Close from "../Modal/Close";
import Survey from "../Modal/Survey";
import VoiceAgent from "../Modal/VoiceAgent";
import IntroText from "../common/IntroText";
import Loading from "../Modal/Loading";
// import useChatControl from "../../hooks/agent/useChatControl";
import useChatControl from "#features/Chat/hooks/agent/useChatControl";
import { useNavigate } from "react-router-dom";
import useIOSVersion from "../../../../hooks/useIOSVersion";
import useReactGASend from "../../../../hooks/useReactGASend";
import useCheckChatStatus from "#src/features/Incomming/hooks/useCheckChatStatus.js";
import { useDispatch } from "react-redux";
import { initUnavailableCount, setMessage } from "#src/modules/reducers/chat/agent/connectChatServer.js";
import { initUnavailableCount  as initSendbirdStatus } from "#src/modules/reducers/chat/agent/getSendbirdStatus.js";
import { ConnectionStateProvider } from "../../hooks/communication/useReconnectionHandler";
import { shouldShowSurveyForTicket } from "../../utils/shouldShowSurveyForTicket";

const Agent = () => {
  useCheckChatStatus();
  const dispatch = useDispatch();
  const [appId, userId, accessToken, channelUrl, startingPoint, ticketId] = useChatInit();
  const {
    openCloseChatModal,
    closeCloseChatModal,
    handleTransferNumberChange,
    handleDelayed,
    transferNumber,
    delayed,
    handleTicketClose,
    handleSurvey,
    closeModal,
    ticketClose,
    closedForCall,
    handleIsOperating,
    isOperating,
    isCloseModalOpen,
    setIsCloseModalOpen,
    isSurveyModalOpen,
    setIsSurveyModalOpen,
    isVoiceAgentModalOpen,
    setIsVoiceAgentModalOpen,
    isLoadingModalOpen,
    setIsLoadingModalOpen,
    handleConnectChatCancle,
  } = useChatControl();
  const { isIOS14_0_1OrBelow } = useIOSVersion();
  const navigate = useNavigate();
  {
    isIOS14_0_1OrBelow && navigate("/block");
  }
  const { makeEventTrackFn } = useReactGASend();

  useEffect(() => {
    dispatch(initUnavailableCount());
    dispatch(initSendbirdStatus());
  }, [])

  return (
    <div className="pt-8 pb-12">
      <IntroText
        title={"안녕하세요\n상담원이 직접\n도와드리겠습니다."}
        // desc={"채팅 내용은 상담 품질 관리를 위해 저장됩니다."}
        // extra={
        //   "2018년 10월 18일부터 산업안전보건법에 고객응대근로자 보호조치가 시행되었습니다. 고객님의 따뜻한 말 한마디가 상담사 에게 큰 힘이 됩니다. 고객응대 근로자에게 폭언 욕설 등을 하지 말아주세요."
        // }
      />

      <SendBirdProvider 
        appId={appId} userId={userId} accessToken={accessToken}
        sdkInitParams={{
          localCacheEnabled: true,
        }}
        stringSet={{
          TRYING_TO_CONNECT: '메시지 전송에 일시적인 오류가 있습니다',
          PLACE_HOLDER__WRONG: '오류가 발생했습니다',
          PLACE_HOLDER__RETRY_TO_CONNECT: '재연결 중 입니다'
        }}
      >
      <ConnectionStateProvider
        channelUrl={channelUrl}
        ticketId={ticketId}
        ticketClose={ticketClose}
        onTicketClosed={(ticketData) => {
          handleTicketClose(true);
          if (shouldShowSurveyForTicket(ticketData)) {
            handleSurvey(true);
          }
        }}
      >
        {!ticketClose && (
          <ActionButton
            onClick={() => {
              // openCloseChatModal();
              navigate("/chat/agent?close=true");
              handleSurvey(true);
              makeEventTrackFn({
                category: "event",
                action: "상담종료(고객)",
              });
            }}
          >
            상담종료
          </ActionButton>
        )}

        <GroupChannelProvider
          isMessageGroupingEnabled={false}
          disableUserProfile
          channelUrl={channelUrl}
          startingPoint={startingPoint}
        >
          <GroupChannelUI
            renderChannelHeader={() => null}
            renderTypingIndicator={() => null}
            renderMessageList={() => (
              <CustomMessage
                onTransferNumberChange={handleTransferNumberChange}
                onHandleDelayed={handleDelayed}
                onHandleTicketClose={handleTicketClose}
                onHandleSurvey={handleSurvey}
                closedForCall={closedForCall}
                onHandleIsOperating={handleIsOperating}
                closeModal={closeModal}
                setIsLoadingModalOpen={setIsLoadingModalOpen}
                openCloseChatModal={openCloseChatModal}
              />
            )}
            renderMessageInput={() => {
              return !ticketClose ? <CustomInput /> : null;
            }}
          />
        </GroupChannelProvider>
      </ConnectionStateProvider>
      </SendBirdProvider>

      <Close
        isOpen={isCloseModalOpen}
        onRequestClose={() => closeModal(setIsCloseModalOpen)}
        onClick={() => {
          closeCloseChatModal();
          // closeModal(setIsCloseModalOpen);
          // handleTicketClose(true);
          // openSurvey();
        }}
      />
      <Survey
        isOpen={isSurveyModalOpen}
        onRequestClose={() => {
          closeModal(setIsSurveyModalOpen);
        }}
      />

      <VoiceAgent
        isOpen={isVoiceAgentModalOpen}
        onRequestClose={() => {
          closeModal(setIsVoiceAgentModalOpen);
        }}
        transferNumber={transferNumber}
      />

      <Loading
        isOpen={isLoadingModalOpen}
        onRequestClose={() => {
          closeModal(setIsLoadingModalOpen);
        }}
        delayed={delayed}
        isOperating={isOperating}
        handleConnectChatCancle={handleConnectChatCancle}
      />
    </div>
  );
};

export default Agent;
